const changeExecutorOrgDeniedCauseTax = {
    title: 'Ошибка смены ОПФ',
    description:
        'Нельзя сменить правовую форму исполнителя, если у него есть <b>удержанные средства</b> на оплату налогов. Выведите их и повторите попытку',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default changeExecutorOrgDeniedCauseTax;
